import { render, staticRenderFns } from "./live-player.vue?vue&type=template&id=999c3246&scoped=true"
import script from "./live-player.vue?vue&type=script&lang=js"
export * from "./live-player.vue?vue&type=script&lang=js"
import style0 from "./live-player.vue?vue&type=style&index=0&id=999c3246&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "999c3246",
  null
  
)

export default component.exports